<template>
    <Tabs
        size="md"
        :tabs="tabs"
        :module="`n-box-${nBoxId}`"
        @tabChange="$emit('update:value', $event)"
    />
</template>
<script>
import i18n from '@/i18n'
import Tabs from '@/views/components/tabs'

export default {
    components: {
        Tabs,
    },
    props: {
        value: String,
        nBoxId: Number,
    },
    computed: {
        tabs() {
            return [
                {
                    id: 'pre-calibrated',
                    active: this.value == 'pre-calibrated',
                    title: i18n.t('form.button.preCalibration'),
                },
                {
                    id: 'calibrated',
                    active: this.value == 'calibrated',
                    title: i18n.t('form.button.postCalibration'),
                },
            ]
        },
    },
}
</script>
<style scoped>
.tabs::v-deep {
    max-width: 400px;
}
</style>
